import { render, staticRenderFns } from "./add-organize-account.vue?vue&type=template&id=3145d0b3&scoped=true&"
import script from "./add-organize-account.vue?vue&type=script&lang=js&"
export * from "./add-organize-account.vue?vue&type=script&lang=js&"
import style0 from "./add-organize-account.vue?vue&type=style&index=0&id=3145d0b3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3145d0b3",
  null
  
)

export default component.exports